import triggerDef from './Trigger/block.json';
import contentDef from './Content/block.json';
import popoverDef from './block.json';

export const slugs = {
  popover: popoverDef.name,
  trigger: triggerDef.name,
  content: contentDef.name,
};

export const viewNamespace = slugs.popover;
